const newbieGuideStage = {
  stage1: 'introduction',
  stage2: 'registerItem',
  stage3: 'reviewExperienceApply',
  stage4: 'basicCoupon',
  reward: 'reward',
}
export default newbieGuideStage
